import React, { Component } from "react";
import { Modal, Row, Col } from "antd";
import "./Modal.css";
import Servicos1 from '../imagens/CadServicos/Servicos1.png';
import Servicos2 from '../imagens/CadServicos/Servicos2.png';
import Servicos3 from '../imagens/CadServicos/Servicos3.png';
import Servicos4 from '../imagens/CadServicos/Servicos4.png';
import Servicos5 from '../imagens/CadServicos/Servicos5.png';

export default class CadServicos extends Component {

    render() {

        const { isOpen, onClose } = this.props;

        return (
            <Modal
                title="Como utilizar o Cadastro de Serviços"
                className="modal"
                visible={isOpen}
                destroyOnClose
                onCancel={onClose}
                footer={null}
                width="50%"
                style={{ top: 10 }}
            >
                <Row>
                    <Col xs={24}>
                        <p>Para acessar o Cadastro de Serviços:  </p>

                        <div className="image-wrapper">
                            <img className="img_smaller" src={Servicos1} alt="Serviço 1"/>
                        </div>

                        <div className="gray_bar"></div>  

                        <div className="image-wrapper">
                            <img src={Servicos2} alt="Serviço 2"/>
                        </div>                                            

                        <h3>No cadastro de Serviços nós temos:</h3>
                        <ol>
                            <li>Cadastrar um novo serviço.</li>
                            <li>Tabela de servicos cadastrados.</li>
                            <li>Botão auxiliar para ativar/desativar um serviço.</li>
                            <li>Botões auxiliares para excluir/alterar um serviço.</li>
                            <li>Paginação da tabela de serviços.</li>
                        </ol>

                        <div className="gray_bar"></div>  

                        <h3>Como cadastrar um novo serviço</h3>     

                        <p>
                            Para iniciar o cadastro de serviço primeiramente clique no botão "Adicionar". Depois na tela de cadastro que for aberta preencha as informações
                            corretamente e clique em "Salvar".
                        </p>   
                        <div className="image-wrapper">
                            <img src={Servicos3} alt="Serviço 3"/>
                        </div> 
                        <div className="image-wrapper">
                            <img src={Servicos4} alt="Serviço 4"/>
                        </div>        

                        <p>
                            Alguns campos do cadastro são mais específicos, como o campo de código da NFSe, que é uma sequência numérica 
                            que identifica a atividade prestada e determina a alíquota de ISS. Esse código deve ser fornecido pelo seu agente contábil, ou pode ser verificado
                            com a prefeitura do seu município.
                        </p>   
                        <p>
                            Outro campo importante é o campo do código NBS, que é o código de Nomenclatura Brasileira de Serviços, que é um código utilizado para 
                            classificar serviços e unificar as declarações fiscais. Esse código deve ser fornecido pelo seu agente contábil, ou deve ser buscado online 
                            em sites oficiais do governo. 
                        </p>    
                        <p>
                            O campo de Alíquota NFSe serve para colocar o valor (em porcentagem) de imposto pago, definido por município. Esse valor deve ser fornecido
                            pelo seu agente contábil. 
                        </p>    
                        <p>
                            O campo de Descrição NFSe é o campo que descreve o serviço na nota fiscal. Caso esse campo esteja em branco, quando uma NFSe for emitida essa 
                            descrição que irá aparecer na nota será a Descrição padrão do serviço (primeiro campo do cadastro).
                        </p>       

                        <p>
                            Lembre também que todos os campos que possuem um asterisco(*) são obrigatórios a serem preenchidos.
                        </p> 

                        <div className="gray_bar"></div>  

                        <h3>Desativar/Alterar/Excluir um serviço</h3> 

                        <p>
                            Para fazer alterações no serviço já cadastrado você pode utilizar os botões auxiliares disponíveis na tabela onde mostra todos os serviços 
                            cadastrados. O botão da coluna Situação serve para alterar a situação do Serviço como ativo/inativo, e os botões da lixeria e do lápis servem
                            para excluir ou alterar um serviço respectivamente. 
                        </p>                                                    

                        <div className="image-wrapper">
                            <img src={Servicos5} alt="Serviço 5"/>
                        </div> 
                    </Col>
                </Row>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/tutoriais/CadServicos.js